<template>
	<div class="container">
		<div v-if="infoData" class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--块1-->
			<!-- <div class="block_1">{{ infoData.title }}</div> -->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img class="bg" src="../../assets/img_h5/News_YD.webp" />
				<div class="msg_box">{{ infoData.title }}</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="left">{{ infoData.fabu_time }}</div>
				<div class="right">
					<!-- <img src="../../assets/img_h5/路径 429@2x_副本.png" @click="share1" /> -->
					<img style="width: 21px;position: relative;top: 0px;" src="../../assets/img_h5/路径 1@2x_副本2.png" @click="share2" />
					<img src="../../assets/img_h5/路径 430@2x_副本.png" @click="share3" />
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<!-- <div class="block_3">
				<img :src="infoData.url" />
			</div> -->
			<!--块3-->
			<div class="content" v-html="infoData.content"></div>
			<!--表单-->
			<div v-if="false" class="form_box">
				<div class="title">Healthcare providers, receive 20% off your first order.</div>
				<div class="iframe_box">
					<iframe
						:src="formUrl"
						width="100%"
						height="500px"
						frameborder="0"
						allowfullscreen
					>
					</iframe>
				</div>
			</div>
			<!--表单-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import { resourcesInfo } from '@/api/public_h5';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	metaInfo() {
		return {
			meta: [
				{
					name: "description",
					content: this.metaDescription,
				},{
					name: "keywords",
					content: this.metaKeywords,
				}
			]
		}
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,  //详情数据
			isOne: false,
			isTwo: false,
			isThree: false,
			metaDescription: '',
			metaKeywords: '',
			formUrl: 'https://cordx.com/hbspt-form2.html?t='+new Date().getTime()
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		//请求文章详情
		resourcesInfo({
			//id: that.$route.query.id,
			custom: that.$route.params.resourcesInfoId,
		}).then(res => {
			document.title = res.data.title + ' - CorDx';
			that.metaDescription = res.data.description;
			that.metaKeywords = res.data.keywords;
			that.infoData = res.data;
			//设置OG标签
			that.setOgTag('og:locale', 'en_US');
			that.setOgTag('og:title', res.data.title);
			that.setOgTag('og:description', res.data.description);
			that.setOgTag('og:image', res.data.url);
			that.setOgTag('og:image:width', '1200');
			that.setOgTag('og:image:height', '630');
			that.setOgTag('og:image:type', 'webp');
			that.isLoading = false;
		});
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//设置OG标签
		setOgTag(property, content) {
			const meta = document.querySelector(`meta[property='${property}']`);
			if(meta) {
				meta.setAttribute('content', content);
			} else {
				const newMeta = document.createElement('meta');
				newMeta.setAttribute('property', property);
				newMeta.setAttribute('content', content);
				document.head.appendChild(newMeta);
			}
		},
		share1() {
			let that = this;
			// window.open("https://www.facebook.com/login.php?skip_api_login=1&api_key=966242223397117&signed_next=1&next=https%3A%2F%2Fwww.facebook.com%2Fsharer.php%3Fu%3D"+window.location.href+"&cancel_url=https%3A%2F%2Fwww.facebook.com%2Fdialog%2Fclose_window%2F%3Fapp_id%3D966242223397117%26connect%3D0%23_%3D_&display=popup&locale=zh_CN", 'yt', 'height=600,width=800');
		},
		share2() {
			let that = this;
			// let url = 'https://twitter.com/cordx_us';
			// let text = encodeURIComponent(that.infoData.title);
			// let via = encodeURIComponent('CorDx');
			// let hashtags = encodeURIComponent(that.infoData.keywords);
			// window.location.href = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + text + '&via=' + via + '&hashtags=' + hashtags;
			window.location.href = 'https://twitter.com/cordx_us';
		},
		share3() {
			let that = this;
			// let url = encodeURIComponent('https://www.linkedin.com/company/cordx');
			// let title = encodeURIComponent(that.infoData.title);
			// let summary = encodeURIComponent(that.infoData.keywords);
			// window.location.href = 'https://www.linkedin.com/shareArticle?mini=true&url=' + url + '&title=' + title + '&summary=' + summary;
			window.location.href = 'https://www.linkedin.com/company/cordx';
		},
	}
}
</script>

<style scoped>
>>> .content ol,>>> .content ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .content img{
	max-width: 100%;
	height: auto;
}
/* >>> .content h3 strong{
	font-size: 0.58rem;
}
>>> .content h3 font{
	font-size: 0.58rem;
}
>>> .content h5{
	font-size: 20px;
}
>>> .content h5 font{
	font-size: 20px;
}
>>> .content p{
	padding: 0.32rem 0;
	font-size: 18px;
}
>>> .content p font{
	font-size: 18px;
}
>>> .content li{
	font-size: 18px;
}
>>> .content li::before{
	content: '●';
	padding-right: 0.2rem;
	font-size: 0.24rem;
} */
</style>
<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	.form_box{
		.iframe_box{
			width: 100%;
			padding: 20px;
		}
		.title{
			padding: 20px;
			text-align: center;
			font-size: 18px;
			color: #ffffff;
			background-color: #0B318F;
		}
	}
	.content{
		padding: 0 20px 42px 20px;
	}
	/*块3*/
	.block_3{
		padding: 0 20px 30px 20px;
		img{ width: 100%; }
	}
	/*块2*/
	.block_2{
		display: flex;
		padding: 42px 20px 21px 20px;
		.right{
			flex: 1;
			text-align: right;
			img{
				width: 20px;
				margin-left: 20px;
			}
		}
		.left{
			width: auto;
			font-size: 18px;
			color: #706B69;
		}
	}
	/*块1*/
	.block_1{
		position: relative;
		.msg_box{
			color: #000000;
			font-size: 34px;
			text-align: center;
		}
		img.bg{
			width: 100%;
		}
	}
}
</style>
